module.exports = __webpack_public_path__ + "img/whiteCamera.3647084d.svg";